import { StoryCard } from "@quintype/arrow";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { fallbackImageUrl } from "../../../../constants";

import { getStories } from "./getStories";
import { staticTexts } from "../../../utils/translate";
import "./read-more-stories.m.css";
import { getLocalizationConfig } from "../../../collection-templates/utils";

const ReadMoreStories = () => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const lang = get(qtState, ["config", "publisher-attributes", "lang"], "");
  const localizationObject = getLocalizationConfig(lang);

  const [alsoReadStories, setAlsoReadStories] = useState(null);
  const [offset, setOffset] = useState(0);
  const [checker, setChecker] = useState(4);

  const getAlsoReadStories = async () => {
    const stories = await getStories(5);
    setAlsoReadStories(stories);
  };

  useEffect(() => {
    getAlsoReadStories();
  }, []);

  if (!alsoReadStories) {
    return null;
  }

  const config = {
    localizationConfig: { ...localizationObject, showAuthor: false, showTime: false, showReadTime: false },
    fallbackImageUrl: fallbackImageUrl,
    showSection: false,
  };

  const dispatch = useDispatch();

  const setLoading = (isloading) => {
    dispatch(isloading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" });
  };

  const fetchStories = async () => {
    setLoading(true);
    const currentOffset = offset + 4;
    setChecker(checker + 4);
    setOffset(currentOffset);

    const stories = await getStories(4, currentOffset + 1);
    setAlsoReadStories(alsoReadStories.concat(stories));
    setLoading(false);
  };

  return (
    <div styleName="wrapper" className="read-more-wrapper">
      <div styleName="heading">{staticTexts(lang).readMoreStoriesHeading}</div>
      <div styleName="stories-wrapper">
        {alsoReadStories.slice(0, checker).map((story, index) => (
          <StoryCard story={story} config={config} aspectRatio={[[16, 9]]} isHorizontalWithImageLast key={index} />
        ))}
      </div>
      {alsoReadStories.length > checker && (
        <button aria-label="read-more-button" onClick={fetchStories} styleName="read-more-button">
          {staticTexts(lang).readMoreStoriesButton}
        </button>
      )}
    </div>
  );
};

export default ReadMoreStories;
